import * as React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Helmet from "react-helmet";
import { Redirect } from "react-router";

// Config
import AppConfig from "../Config/AppConfig";

// Routes
import Routes from "./Routes";
import NoMatch from "./NoMatch";

// Nav items
import { NAV_ITEMS } from "./NavItems";

// Sidebar nav
import SideBar from "../Components/Sidebar";

// Utils
import { AUTH_USER_TOKEN } from "../Utils/LocalStorage";
import { validateToken } from "../Utils/Helpers";

const validateUserAuth = (): boolean => {
  // Check if token is valid
  if (!validateToken(window.localStorage.getItem(AUTH_USER_TOKEN))) {
    return false;
  }

  return true;
};

const AuthRoute = (props: any) => {
  const Comp = props.component;

  return props.private && !validateUserAuth() ? (
    <Redirect to="/sign-in" />
  ) : props.private && validateUserAuth() ? (
    <SideBar
      navItems={NAV_ITEMS}
      {...props}
      render={<Route render={data => <Comp {...data} {...props} />} />}
    />
  ) : (
    <Route render={data => <Comp {...data} {...props} />} />
  );
};

const AppNavigation = () => (
  <Router>
    <React.Fragment>
      <Helmet
        defaultTitle={AppConfig.appName}
        titleTemplate={`${AppConfig.appName} | %s`}
      />
      <Switch>
        {Routes.map((route, i) => {
          return <AuthRoute key={i} {...route} />;
        })}
        <Route component={NoMatch} />
      </Switch>
    </React.Fragment>
  </Router>
);

export default AppNavigation;



// WEBPACK FOOTER //
// ./src/Navigation/AppNavigtation.tsx